export const LS_KEY = 'pfaroe-insurance-settings';
